export async function cacheVideoForOffline(url: string) {
  if (!("serviceWorker" in navigator) || !import.meta.env.PROD) return;
  try {
    if (navigator.storage?.persist) await navigator.storage.persist();
    const registration = await navigator.serviceWorker.ready;
    const worker = registration.active;
    if (!worker) return;
    const channel = new MessageChannel();
    await new Promise<{ ok: boolean; cached?: boolean; contentLength?: number; error?: string }>((resolve) => {
      channel.port1.onmessage = (event) => resolve(event.data);
      worker.postMessage({ type: "CACHE_VIDEO", url }, [channel.port2]);
    });
  } catch { /* Offline caching is optional. */ }
}
